
<template>
    <div class="bet-history-container">
      <h2 class="bet-history-title">My Bets</h2>
      <div v-if="betData.length === 0" class="empty-history">
        <p>There's nothing here yet.</p>
        <span>Transactions will show up when you place bets.</span>
      </div>
      <div v-else class="bet-list">
        <div
          v-for="(transaction, index) in betData"
          :key="index"
          class="bet-card"
        >
          <div class="bet-card-header">
            <div>
              <p class="game-name">{{ transaction?.GameName || "N/A" }}</p>
              <p class="provider">{{ transaction?.Provider }}</p>
            </div>
            <div class="status-badge" :class="transaction.Status">
              {{ transaction.Status.toUpperCase() }}
            </div>
          </div>
  
          <div class="bet-card-body">
            <div class="bet-info-row">
              <span>Bet Time:</span>
              <span>{{ formatDateTime(transaction?.BetTime) }}</span>
            </div>
            <div class="bet-info-row">
              <span>Event:</span>
              <span>{{ transaction?.EventType }}</span>
            </div>
            <div class="bet-info-row">
              <span>Amount:</span>
              <span class="amount-text">
                {{ transaction?.Amount }} {{ transaction?.currency }}
              </span>
            </div>
            <div class="bet-info-row">
              <span>Result:</span>
              <span
                :class="{
                  win: transaction.WinLoss > 0,
                  lose: transaction.WinLoss == 0,
                  pending: transaction.Status === 'BET',
                }"
              >
                {{
                  transaction.Status === "BET"
                    ? "Pending":transaction.Status==="CANCELED"?transaction?.WinLoss
                    : transaction.WinLoss > 0
                    ? `+${transaction.WinLoss}`
                    : `-${transaction.Amount}`
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        betData: [],
        demoData:[
  {
    BetTime: "2025-03-23T14:30:00Z",
    EventType: "Casino",
    Provider: "Evolution",
    GameName: "Crazy Time",
    Amount: 50,
    WinLoss: 100,
    currency: "USD",
    Status: "settled",
  },
  {
    BetTime: "2025-03-23T16:45:00Z",
    EventType: "Sports",
    Provider: "Bet365",
    GameName: "Man Utd vs Chelsea",
    Amount: 30,
    WinLoss: 0,
    currency: "USD",
    Status: "settled",
  },
  {
    BetTime: "2025-03-23T18:10:00Z",
    EventType: "Casino",
    Provider: "Pragmatic Play",
    GameName: "Sweet Bonanza",
    Amount: 25,
    WinLoss: 0,
    currency: "USD",
    Status: "running",
  },
  {
    BetTime: "2025-03-23T19:00:00Z",
    EventType: "Casino",
    Provider: "Evolution",
    GameName: "Lightning Roulette",
    Amount: 40,
    WinLoss: 200,
    currency: "USD",
    Status: "settled",
  },
  {
    BetTime: "2025-03-23T20:00:00Z",
    EventType: "Sports",
    Provider: "Betway",
    GameName: "Real Madrid vs Barca",
    Amount: 60,
    WinLoss: 0,
    currency: "USD",
    Status: "settled",
  }
]
      };
    },
    created() {
      this.fetchBetHistory();
    },
    methods: {
      async fetchBetHistory() {
        const token = localStorage.getItem("userToken");
        const usernametoken = localStorage.getItem("usernameToken");
        if (!token || !usernametoken) {
          return;
        }
        try {
          const response = await fetch(
            `${process.env.VUE_APP_API_KEY}/api/bet/get-all-bet-user?status=all&page=1&limit=20&site_auth_key=${this.SITEAUTHKEY}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                token: token,
                usernametoken: usernametoken,
              },
            }
          );
          if (response.status !== 200) {
            throw new Error("Failed to fetch bet history");
          }
          const data = await response.json();
          this.betData = data.data;
        } catch (error) {
          console.error("Error fetching transactions:", error);
        }
      },
      formatDateTime(dateString) {
        const date = new Date(dateString);
        return date.toLocaleString();
      },
    },
  };
  </script>
  
  <style scoped>
  .bet-history-container {
    padding: 16px;
    min-height: 100vh;
    color: #f0f0f0;
    margin-bottom: 70px;
  }
  .bet-history-title {
    font-size: 22px;
    margin-bottom: 12px;
    color: #ffffff;
  }
  .empty-history {
    margin-top: 80px;
    text-align: center;
    color: #999;
  }
  .empty-history p {
    font-size: 18px;
    margin-bottom: 6px;
  }
  .bet-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .bet-card {
    background: black;
    border-radius: 10px;
    padding: 12px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  }
  .bet-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #333;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }
  .game-name {
    font-weight: bold;
    color: #ffffff;
  }
  .provider {
    font-size: 12px;
    color: #aaa;
  }
  .status-badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
  }
  .status-badge.running {
    background-color: orange;
  }
  .status-badge.settled {
    background-color: #4ade80;
  }
  .status-badge.won {
    background-color: #4ade80;
  }
  .status-badge.WIN {
    background-color: #4ade80;
  }
  .status-badge.CANCELED {
    background-color: #ef4444;
  }
  .status-badge.lose {
    background-color: #ef4444;
  }
  .bet-card-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .bet-info-row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
  }
  .amount-text {
    color: #4da6ff;
    font-weight: bold;
  }
  .win {
    color: #4ade80;
    font-weight: bold;
  }
  .lose {
    color: #ef4444;
    font-weight: bold;
  }
  .pending {
    color: orange;
    font-weight: bold;
  }
  </style>
  